/**
 * State for the Entity Inspector UI.
 */
export interface EntityInspectorState {
  isOpen: boolean;
  selectedEntityId: number | undefined;
  lastUpdateTick: number;
}

/**
 * Service for managing the Entity Inspector debug feature.
 */
export class EntityInspectorService {
  public state: EntityInspectorState = {
    isOpen: false,
    selectedEntityId: undefined,
    lastUpdateTick: 0,
  };

  /**
   * Toggle the inspector panel.
   */
  public toggle(): void {
    this.state.isOpen = !this.state.isOpen;
  }

  /**
   * Update the inspector state to trigger reactivity.
   */
  public update(): void {
    if (this.state.isOpen) {
      this.state.lastUpdateTick++;
    }
  }

  /**
   * Open the inspector panel.
   */
  public open(): void {
    this.state.isOpen = true;
  }

  /**
   * Close the inspector panel.
   */
  public close(): void {
    this.state.isOpen = false;
  }

  /**
   * Select an entity to view details for.
   */
  public selectEntity(entityId: number | undefined): void {
    this.state.selectedEntityId = entityId;
  }
}
